import { Draggable } from "react-beautiful-dnd";
import styles from "./Flag.module.css";
import FlagMapper from "../../Util/FlagMapper";
import {
  AlertOutlined,
  BranchesOutlined,
  CloseOutlined,
  EditFilled,
  MoreOutlined,
  RocketFilled,
  StarFilled,
  WarningOutlined,
} from "@ant-design/icons";
import { Avatar, Popover, Tag, Tooltip } from "antd";
import { BookmarkOutlined } from "@mui/icons-material";
import moment from "moment";
import { memo, useMemo } from "react";
import ControlCameraIcon from "@mui/icons-material/ControlCamera";
import SellIcon from "@mui/icons-material/Sell";
import ErrorIcon from "@mui/icons-material/Error";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { dateBaseFlags } from "../../constants/dateBaseFlags";
import { notImportantPreFlags } from "../../constants/notImportantPreFlags";
import { freeFlags } from "../../constants/freeFlags";

const Flag = ({
  id,
  deletedBy,
  merged = false,
  conflicts = [],
  termIndex,
  type,
  flagImportance = 0,
  renderFromFlagsMenu = false,
  roadmapLimiterOnHistory = false,
  overFlowWarning = false,
  removeOrAdd = false,
  toggleTermIndex = false,
  title,
  isTransparent = false,
  ignoredFromLimiter = false,
  existsInDeleteList = false,
  existsInOtherRoadmaps = false,
  index,
  description,
  flagRef,
  skills,
  hidden,
  onEdit,
  operatorData,
  hide,
  active,
  toggleConfirmation,
  deleteFlag = () => {},
  toggleImportance = () => {},
  confirmed,
  autoGenerated,
  bookmarkGenerated,
  termIndexFinder,
  postConditionFlags,
  preConditionFlags,
  postConditionGenerated,
  preConditionGenerated,
  addedUser,
  addedDate,
  bookmarkQuestionId,
  createdAt,
  forcedToMoved,
  report,
  supervisorConfirm,
}) => {
  const flagData = FlagMapper(type);
  const nowDate = moment();
  const createdData = moment(
    flagRef && flagRef.createdAt ? flagRef.createdAt : createdAt,
  );

  const isNewFlag = nowDate.diff(createdData, "days") <= 7;

  const isDateBaseFlag = useMemo(
    () => (dateBaseFlags.find((e) => e.id == id) ? true : false),
    [id],
  );

  const isFreeFlag = useMemo(
    () => (freeFlags.find((e) => e.id == id) ? true : false),
    [id],
  );

  const isNotImportantFlag = useMemo(
    () => (notImportantPreFlags.find((e) => e.id == id) ? true : false),
    [id],
  );

  let isValidFlag = true;
  // if (Array.isArray(skills) && skills.length === 0 && hidden) {
  //   isValidFlag = false;
  // }
  // if (!hidden && `${description}`.length < 10) {
  //   isValidFlag = false;
  // }

  const relatedQuestionList = () => {
    if (autoGenerated?.relatedQuestions?.length === 0) {
      return (
        <div>
          {/* if array of qa not exists */}
          {!autoGenerated.relatedQuestions && (
            <div>
              <b>ساخته شده بر پایه پاسخ</b>
              <div>{autoGenerated.question}</div>
              <b>{autoGenerated.answer}</b>
            </div>
          )}
        </div>
      );
    }

    // related questions exists
    return (
      <div>
        {autoGenerated?.relatedQuestions &&
          autoGenerated?.relatedQuestions?.map((qa) => (
            <div>
              <b>ساخته شده بر پایه پاسخ</b>
              <div>{qa.question}</div>
              <b>{qa.answer}</b>
              {termIndexFinder && (
                <div>
                  جایگاه: {termIndexFinder(qa?.id, flagRef?.id, qa?.answer_id)}
                </div>
              )}
              <div
                style={{
                  backgroundColor: "white",
                  height: "2px",
                  width: "100%",
                }}
              ></div>
            </div>
          ))}
      </div>
    );
  };

  const termIndexMin = (autoGenerated, relatedQuestions) => {
    let result = -1;
    const tempIndexes = [];

    let termIndex = termIndexFinder(
      autoGenerated?.id,
      flagRef?.id,
      autoGenerated?.answer_id,
    );

    if (termIndex || termIndex === 0) {
      tempIndexes.push(termIndex);
    }

    if (relatedQuestions) {
      relatedQuestions?.forEach((el) => {
        const tempTerm = termIndexFinder(el?.id, flagRef?.id, el?.answer_id);

        if (tempTerm || tempTerm === 0) {
          tempIndexes.push(tempTerm);
        }
      });
    }

    if (tempIndexes.length === 0) return -1;

    const nonZeroTermsIndex = tempIndexes.filter((o) => o !== 0);
    const zeroTermsIndex = tempIndexes.filter((o) => o === 0);

    if (nonZeroTermsIndex.length !== 0) {
      result = Math.min(...tempIndexes.filter((o) => o !== 0));

      if (result === 4 && zeroTermsIndex.length !== 0) return 0;

      return result;
    } else {
      return zeroTermsIndex.length === 0 ? -1 : 0;
    }
  };

  const getBorderColor = () => {
    if ((overFlowWarning && !ignoredFromLimiter) || roadmapLimiterOnHistory)
      return "4px solid red";
    if (conflicts?.length > 0) return "4px solid yellow";
    if (isDateBaseFlag) return "4px solid rgb(155, 59, 11)";
    if (isFreeFlag || isNotImportantFlag) return "4px solid #CA89FF";
    if (merged) return "4px solid orange";
    if (toggleTermIndex) return "4px solid green";
    if (removeOrAdd) return "4px solid blue";
    return "";
  };

  const getFlagOpacity = () => {
    // if (!supervisorConfirm) return "0.4";

    if (isTransparent) {
      if (toggleTermIndex || removeOrAdd) {
        return "1";
      } else {
        return "0.2";
      }
    }
    return "1";
  };

  const finalDeletedByOperator = deletedBy ?? operatorData;

  return (
    <>
      {!hide && (
        <Draggable
          isDragDisabled={
            !isValidFlag
            // || !supervisorConfirm
          }
          draggableId={`${id}`}
          index={index}
        >
          {(provided) => (
            <div
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
            >
              <div
                style={{
                  opacity: getFlagOpacity(),
                  backgroundColor: hidden ? "whitesmoke" : flagData.titleColor,
                  color: hidden ? "black" : "white",
                  border: getBorderColor(),
                }}
                className={[
                  styles.Flag,
                  active ? styles.Active : null,
                  isValidFlag ? null : styles.Error,
                ].join(" ")}
              >
                <div className={styles.CardHeader}>
                  <div className={styles.Icon}>{flagData.icon}</div>
                  <h3 className={styles.Type}>{flagData.title}</h3>
                </div>

                <div className={styles.ButtonContainer}>
                  <div
                    onClick={() => {
                      // toggleConfirmation();
                      deleteFlag(id);
                    }}
                    className={[
                      styles.Button,
                      // confirmed ? styles.Confirmed : styles.NeedToConfirm,
                      existsInDeleteList
                        ? styles.Confirmed
                        : styles.NeedToConfirm,
                    ].join(" ")}
                  >
                    <CloseOutlined />
                  </div>
                  <div
                    onClick={() => {
                      onEdit();
                    }}
                    className={[
                      styles.Button,
                      flagRef
                        ? flagRef.description !== description
                          ? styles.Edited
                          : null
                        : null,
                    ].join(" ")}
                  >
                    <EditFilled />
                  </div>
                  {
                    <Popover
                      placement="bottom"
                      title="بیشتر"
                      content={
                        <div className={styles.Skills}>
                          {Array.isArray(skills) && skills.length > 0 && (
                            <>
                              <div>
                                <b>مهارت‌ها:</b>
                              </div>
                              {skills.map((el) => {
                                return (
                                  <Tag className={styles.Skill} key={el.id}>
                                    {" "}
                                    {el.title}{" "}
                                  </Tag>
                                );
                              })}{" "}
                            </>
                          )}
                        </div>
                      }
                    >
                      <div className={styles.Button}>
                        <MoreOutlined />
                      </div>
                    </Popover>
                  }
                </div>
                <div className={styles.Main}>
                  <p className={styles.Title}>{title}</p>
                  {hidden && (
                    <p className={styles.NotShowInFLag}>
                      {" "}
                      <b>عدم نمایش در نقشه راه</b>
                    </p>
                  )}
                  <div className={styles.TagContainer}>
                    {isNewFlag && (
                      <Tooltip title="کارت در 7 روز گذشته ساخته شده است.">
                        <Tag color="gold" className={styles.Tag}>
                          <StarFilled />
                        </Tag>
                      </Tooltip>
                    )}
                    {addedUser && (
                      <Popover
                        content={
                          <div className={styles.UserData}>
                            <Avatar size="large">
                              {`${addedUser.username}`[0].toUpperCase()}
                            </Avatar>
                            <div>
                              {addedUser.firstname + " " + addedUser.lastname}
                            </div>
                            <div className={styles.UserName}>
                              {addedUser.username + "@"}
                            </div>
                            <Tag color="blue">{addedUser.role}</Tag>
                            <div className={styles.AddDate}>
                              {moment(addedDate).fromNow()}
                            </div>
                          </div>
                        }
                      >
                        <Tag color="purple" className={styles.Tag}>
                          <span style={{ paddingTop: "0.125rem" }}>
                            {addedUser.username[0].toUpperCase() +
                              addedUser.username[1].toUpperCase()}
                          </span>
                        </Tag>
                      </Popover>
                    )}
                    {renderFromFlagsMenu &&
                      removeOrAdd &&
                      finalDeletedByOperator && (
                        <Popover
                          content={
                            <div className={styles.UserData}>
                              <Avatar size="large">
                                {`${finalDeletedByOperator?.username}`.toUpperCase()}
                              </Avatar>
                              <div>
                                {finalDeletedByOperator?.firstname +
                                  " " +
                                  finalDeletedByOperator?.lastname}
                              </div>
                              <div className={styles.UserName}>
                                {finalDeletedByOperator?.username + "@"}
                              </div>
                              <Tag color="blue">
                                {finalDeletedByOperator?.role}
                              </Tag>
                            </div>
                          }
                        >
                          <Tag color="purple" className={styles.Tag}>
                            <span style={{ paddingTop: "0.125rem" }}>
                              {finalDeletedByOperator?.username[0]?.toUpperCase() +
                                finalDeletedByOperator?.username[1]?.toUpperCase()}
                            </span>
                          </Tag>
                        </Popover>
                      )}
                    {autoGenerated && (
                      <Tooltip
                        title={autoGenerated?.id && relatedQuestionList()}
                      >
                        <Tag color="cyan" className={styles.Tag}>
                          <RocketFilled />
                        </Tag>
                      </Tooltip>
                    )}
                    {conflicts?.length > 0 && (
                      <Popover
                        title="تعارض"
                        content={
                          <div className={styles.UserData}>
                            {conflicts?.map((e) => (
                              <Tag
                                color="red"
                                key={e.id}
                                style={{ margin: "2px" }}
                              >
                                {e.title}
                              </Tag>
                            ))}
                          </div>
                        }
                      >
                        <Tag color="red" className={styles.Tag}>
                          <ErrorIcon
                            fontSize="small"
                            style={{ scale: "0.7" }}
                          />
                        </Tag>
                      </Popover>
                    )}

                    {existsInOtherRoadmaps && (
                      <Tooltip title=" کارت تکراری">
                        <Tag color="magenta" className={styles.Tag}>
                          <ContentCopyIcon
                            fontSize="small"
                            style={{ scale: "0.7" }}
                          />
                        </Tag>
                      </Tooltip>
                    )}

                    {flagRef?.flagCategory?.length > 0 && (
                      <Popover
                        content={
                          <div className={styles.UserData}>
                            {flagRef?.flagCategory?.map((e) => (
                              <Tag
                                color="blue"
                                key={e}
                                style={{ margin: "2px" }}
                              >
                                {e}
                              </Tag>
                            ))}
                          </div>
                        }
                      >
                        <Tag color="blue" className={styles.Tag}>
                          <SellIcon fontSize="small" style={{ scale: "0.7" }} />
                        </Tag>
                      </Popover>
                    )}

                    {
                      <Tooltip title={<div>اهمیت پرچم</div>}>
                        <Tag
                          color="orange"
                          className={styles.Tag}
                          onClick={() => toggleImportance(id)}
                        >
                          {flagImportance}
                        </Tag>
                      </Tooltip>
                    }

                    {termIndexFinder &&
                      (autoGenerated?.id || bookmarkQuestionId) && (
                        <Tooltip title={<div>جایگاه</div>}>
                          <Tag color="cyan" className={styles.Tag}>
                            {autoGenerated?.id
                              ? termIndexMin(
                                  autoGenerated,
                                  autoGenerated.relatedQuestions,
                                )
                              : termIndexFinder(
                                  bookmarkQuestionId,
                                  flagRef?.id,
                                  null,
                                )}
                          </Tag>
                        </Tooltip>
                      )}

                    {forcedToMoved && (
                      <Tooltip title="کارت به علت تعادل جا‌به‌جا شده است">
                        <Tag color="orange" className={styles.Tag}>
                          <ControlCameraIcon
                            style={{ fontSize: "0.9rem" }}
                            fontSize="small"
                          />
                        </Tag>
                      </Tooltip>
                    )}
                    {bookmarkGenerated && (
                      <Tooltip title={bookmarkGenerated}>
                        <Tag color="blue" className={styles.Tag}>
                          <BookmarkOutlined
                            style={{ width: "0.6em", height: "0.65em" }}
                          />
                        </Tag>
                      </Tooltip>
                    )}
                    {preConditionGenerated && (
                      <Tooltip
                        title={
                          <span>
                            {" "}
                            ساخته شده به علت پیش نیاز بودن برای کارت :{" "}
                            <b> {preConditionGenerated.title} </b>
                          </span>
                        }
                      >
                        <Tag color="lime" className={styles.Tag}>
                          <BranchesOutlined
                            style={{ width: "0.6em", height: "0.65em" }}
                          />
                        </Tag>
                      </Tooltip>
                    )}
                    {postConditionGenerated && (
                      <Tooltip
                        title={
                          <span>
                            {" "}
                            ساخته شده به علت پس نیاز بودن برای کارت :{" "}
                            <b> {postConditionGenerated.title} </b>
                          </span>
                        }
                      >
                        <Tag color="geekblue" className={styles.Tag}>
                          <BranchesOutlined
                            style={{ width: "0.6em", height: "0.65em" }}
                          />
                        </Tag>
                      </Tooltip>
                    )}
                    {report &&
                      (report?.post?.length > 0 || report?.pre?.length > 0) && (
                        <Tooltip
                          title={
                            <span>
                              {report?.post?.length > 0 && (
                                <>
                                  <b>
                                    ساخته شده به علت پس نیاز بودن برای کارت :
                                  </b>
                                  {report?.post.map((e) => (
                                    <div> {e.title} </div>
                                  ))}
                                </>
                              )}
                              {report?.pre?.length > 0 && (
                                <>
                                  <b>
                                    ساخته شده به علت پیش نیاز بودن برای کارت :
                                  </b>
                                  {report?.pre.map((e) => (
                                    <div> {e.title} </div>
                                  ))}
                                </>
                              )}
                            </span>
                          }
                        >
                          <Tag color="geekblue" className={styles.Tag}>
                            <BranchesOutlined
                              style={{ width: "0.6em", height: "0.65em" }}
                            />
                          </Tag>
                        </Tooltip>
                      )}
                    {((Array.isArray(preConditionFlags) &&
                      preConditionFlags.length > 0) ||
                      (Array.isArray(postConditionFlags) &&
                        postConditionFlags.length > 0)) && (
                      <Tooltip
                        title={
                          <div>
                            <b>دارای کارت پیش نیاز یا پس نیاز</b>
                            {Array.isArray(preConditionFlags) &&
                              preConditionFlags.length > 0 && (
                                <>
                                  <div>
                                    <h5 style={{ marginBottom: 0 }}>
                                      کارت‌های پیش نیاز:
                                    </h5>
                                  </div>
                                  <ul className={styles.ConditionFlagList}>
                                    {preConditionFlags.map((el) => {
                                      return (
                                        <li
                                          className={styles.Skill}
                                          key={el.id}
                                        >
                                          {" "}
                                          {el.title}{" "}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </>
                              )}
                            {Array.isArray(postConditionFlags) &&
                              postConditionFlags.length > 0 && (
                                <>
                                  <div>
                                    <h5 style={{ marginBottom: 0 }}>
                                      کارت‌های پس نیاز:
                                    </h5>
                                  </div>
                                  <ul className={styles.ConditionFlagList}>
                                    {postConditionFlags.map((el) => {
                                      return (
                                        <li
                                          className={styles.Skill}
                                          key={el.id}
                                        >
                                          {el.title}{" "}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </>
                              )}
                          </div>
                        }
                      >
                        <Tag color="red" className={styles.Tag}>
                          <AlertOutlined />
                        </Tag>
                      </Tooltip>
                    )}
                    {autoGenerated?.conflict && (
                      <Tooltip
                        title={
                          <div>
                            <b>کانفلیکت در ترتیب</b>
                          </div>
                        }
                      >
                        <Tag color="orange" className={styles.Tag}>
                          <WarningOutlined />
                        </Tag>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Draggable>
      )}
    </>
  );
};
export default memo(Flag);
